// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1QvOCLpLZH0HIm {\n  padding-left: 5px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"learnMoreLink": "_1QvOCLpLZH0HIm"
};
export default ___CSS_LOADER_EXPORT___;
